import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'liberro-header-submenu-tile',
  standalone: false,
  templateUrl: './liberro-header-submenu-tile.component.html',
  styleUrl: './liberro-header-submenu-tile.component.less'
})
export class LiberroHeaderSubmenuTileComponent {
  @Input() public icon = '';
  @Input() public productsKey = '';
  @Input() public route = '';
  @Input() public fragment?: string;
  @Output() public actionBtnClicked = new EventEmitter<void>();

  // todo: connect to flow via select-strategy-type page
  public onActionBtnClick(): void {
    this.actionBtnClicked.emit();
  }
}
